// Listen for form submit event from AlpineJS.
document.addEventListener('form-submit', function (event) {
    const payload = event.detail;

    // Cater for multiple forms on the same page.
    if (payload.form_name === 'js_self_assessment_start_form') {

        // Push data into the dataLayer
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'self_assessment_start_form',
            // eventData: payload.form_data, // Are you sure? We probably don't want to send the form data to GA.
            formID: payload.form_id,
            formName: payload.form_name,
        });
    }
});
